const DEFAULT_LOCALE = 'en';
const callApi_file = (url,
  config,
  onRequestSuccess,
  onRequestFailure) => {
  if (config.method.toUpperCase() === 'GET') {
    new URL(url);
  } else if (config.body) {
    if (config.body instanceof FormData) {
      config.body.append('locale', config.body.locale || localStorage.LANG || DEFAULT_LOCALE);
    } else {
      const bodyData = JSON.parse(config.body);
      config.body = JSON.stringify(bodyData);
    }
  } else {
    config.body = JSON.stringify({
      locale: localStorage.LANG || DEFAULT_LOCALE,
    });
  }

  fetch(url, config)
    .then((response) => {
      if (response.status === 401 && !/\/oauth\/token$/.test(url)) {
        localStorage.removeItem('ACCESS_TOKEN');
        localStorage.removeItem('REFRESH_TOKEN');
        localStorage.removeItem('MEMBER');
        localStorage.removeItem('MENUS');
        document.cookie = `ACCESS_TOKEN=`
        document.cookie = `REFRESH_TOKEN=`
        window.location.href = '/login';
      }
      if (config.method.toUpperCase() === 'POST') {
        return response.json();
      } else {
        return response.arrayBuffer();
      }
    })
    .then((data) => onRequestSuccess(data))
    .catch((err) => onRequestFailure(err));
};

export { callApi_file, DEFAULT_LOCALE };
